import { sleep } from './promise_helper.js';
export async function waitForJobToComplete(getJobFunction, queueName, jobType, jobId, maxNumberOfTries, currentAttempt) {
    await sleep(1000);
    const fullJobId = `${jobType}-${jobId}`;
    const jobStatus = await getJobFunction(queueName, fullJobId);
    if (!jobStatus) {
        throw new Error(`Job ${fullJobId} not found`);
    }
    if (jobStatus.jobState === 'completed') {
        return jobStatus;
    }
    // Safety to stop us from an infinite loop
    if (currentAttempt > maxNumberOfTries) {
        return jobStatus;
    }
    return waitForJobToComplete(getJobFunction, queueName, jobType, fullJobId, maxNumberOfTries, currentAttempt + 1);
}
//# sourceMappingURL=job_helper.js.map